import dayjs from 'dayjs';

export type PreviousRangeMode = 'yoy' | 'duration';

export type PreviousRange = {
	prevFrom: Date;
	prevTo: Date;
	mode: PreviousRangeMode;
};

// Ranges ≤ 12 months use YoY (homologous, preserves seasonality).
// Ranges > 12 months use a contiguous previous period of equal duration (avoids overlap).
export const getPreviousRange = (from: Date, to: Date): PreviousRange => {
	const rangeMonths = dayjs(to).diff(dayjs(from), 'month') + 1;
	if (rangeMonths <= 12) {
		return {
			prevFrom: dayjs(from).subtract(1, 'year').toDate(),
			prevTo: dayjs(to).subtract(1, 'year').toDate(),
			mode: 'yoy',
		};
	}
	const durationDays = dayjs(to).diff(dayjs(from), 'day');
	const prevTo = dayjs(from).subtract(1, 'day').toDate();
	const prevFrom = dayjs(prevTo).subtract(durationDays, 'day').toDate();
	return { prevFrom, prevTo, mode: 'duration' };
};
